export function getClientWithStatus(factory, key, trafficType) {
  var client = key ? factory.client(key, trafficType) : factory.client();

  if (!client._trackingStatus) {
    // We cannot use event listeners, since clients might be already Ready or Timedout
    client.ready().then(function () {
      client.isReady = true;
    }, function () {
      client.isTimedout = true; // register a listener for SDK_READY event, that might trigger after a timeout

      client.once(client.Event.SDK_READY, function () {
        client.isReady = true;
      });
    });
    client._trackingStatus = true;
    client.isReady = false;
    client.isTimedout = false;
  }

  return client;
}